import * as React from 'react';
import { Table } from "soprasteria-ui-library";
import { IPatientTreatment } from '../../../../models/IPatientTreatment';
import { dateTimeToDateString } from '../../../../helpers/DateHelper';
import '../../../../assets/styles/table.scss';
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";
import { formatCurrency } from '../../../../helpers/CurrencyHelper';
import { SelectionAreaInvoiceDataRow } from '../../../../models/IInvoice';

interface IBillableTreatmentsTable {
    invoiceDataRows?: IPatientTreatment[] | SelectionAreaInvoiceDataRow[];
}

export const BillableTreatmentsTable: React.FunctionComponent<IBillableTreatmentsTable> = ({ invoiceDataRows }) => {

    const instanceOfPatientTreatment = (object: any[]): object is IPatientTreatment[] => {
        return 'treatmentCodeId' in object[0];
    }

    return (
        <>
            {
                invoiceDataRows ?
                    <Table>
                        <thead>
                            {
                                instanceOfPatientTreatment(invoiceDataRows) ?
                                    <tr>
                                        <th style={{ width: "20%" }}>Behandlingsdatum</th>
                                        <th style={{ width: "20%" }}>Personnummer</th>
                                        <th style={{ width: "20%" }}>Åtgärdskod</th>
                                        <th className="text-right" style={{ width: "20%" }}>Belopp</th>
                                        <th style={{ width: "20%" }}>Status</th>
                                    </tr>
                                    :
                                    <tr>
                                        <th style={{ width: "50%" }}>Beskrivning</th>
                                        <th className="text-right" style={{ width: "50%" }}>Pris</th>
                                    </tr>
                            }
                        </thead>
                        <tbody>
                            {
                                instanceOfPatientTreatment(invoiceDataRows) ?
                                    invoiceDataRows.map((treatment: IPatientTreatment, key) =>
                                        <tr key={key}>
                                            <td style={{ width: "20%" }}>{dateTimeToDateString(treatment.treatmentDate)}</td>
                                            <td style={{ width: "20%" }}>{formatPersonalSecurityNumberAndOrganisationNumber(treatment.patientSocialSecurityNumber)}</td>
                                            <td style={{ width: "20%" }}>{treatment.code}</td>
                                            <td className="text-right text-nowrap" style={{ width: "20%" }}>{formatCurrency(treatment.amount ?? 0)}</td>
                                            <td style={{ width: "20%" }}>{treatment.patientTreatmentStatus}</td>
                                        </tr>
                                    )
                                    :
                                    invoiceDataRows.map((selectionAreaInvoiceDataRow: SelectionAreaInvoiceDataRow, key) =>
                                        <tr key={key}>
                                            <td style={{ width: "50%" }}>{selectionAreaInvoiceDataRow.description}</td>
                                            <td className="text-right" style={{ width: "50%" }}>{formatCurrency(selectionAreaInvoiceDataRow.amount)}</td>
                                        </tr>
                                    )
                            }
                        </tbody>
                    </Table>
                    : null
            }
        </>
    )
}

